import React from 'react';

import { css } from '@emotion/css';
import { Theme } from '@mui/material';

import { FontSizes } from '@/assets/fonts.ts';
import { Icons } from '@/assets/icons.ts';
import { useScroll } from '@/hooks/useScroll.ts';
import { useStyles } from '@/hooks/useStyles';
import { Button } from '@/uiKit/atoms/Button.tsx';

export const BackToTop: React.FC = () => {
  const styles = useStyles(makeStyles);
  const scroll = useScroll();

  return scroll.current > 1000 ? (
    <div className={styles.backToTop}>
      <Button
        variant="contained"
        startIcon={<Icons.chevronUp className={styles.moreContentIcon} />}
        className={styles.moreContentButton}
        onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}
      />
    </div>
  ) : null;
};

const makeStyles = (theme: Theme) => ({
  moreContentButton: css`
    padding: ${theme.spacing(4, 8)};
    color: ${theme.palette.common.white};
  `,
  moreContentIcon: css`
    width: ${FontSizes.bodyLarge};
    height: ${FontSizes.bodyLarge};
  `,
  backToTop: css`
    position: fixed;
    bottom: ${theme.spacing(12)};
    align-self: flex-end;
    z-index: ${theme.zIndex.fab};
    stroke: ${theme.palette.grey[900]};
  `,
});
